import React from 'react';

interface AuthInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
}

const AuthInput: React.FC<AuthInputProps> = ({ 
  label, 
  error, 
  ...props 
}) => {
  return (
    <div>
      <label htmlFor={props.id} className="text-[var(--text-primary)]">
        {label}
      </label>
      <input
        {...props}
        className="w-full px-3 py-2 mt-1 border rounded-md bg-[var(--bg-primary)]/40 border-[var(--brand-primary)]/20 
          text-[var(--text-primary)] placeholder-[var(--text-muted)]
          focus:border-[var(--brand-primary)] focus:outline-none focus:ring-1 focus:ring-[var(--brand-primary)]
          [color-scheme:dark]
          [-webkit-text-fill-color:var(--text-primary)]
          [background-color:var(--bg-primary)_/_0.4_]"
        style={{ 
          caretColor: 'var(--text-primary)',
          WebkitBoxShadow: '0 0 0 30px var(--bg-primary) inset',
          WebkitTextFillColor: 'var(--text-primary)'
        }}
      />
      {error && (
        <p className="mt-1 text-sm text-[var(--error)]">
          {error}
        </p>
      )}
    </div>
  );
};

export default AuthInput; 